import { ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions, useRestQuery } from 'utils/hooks/api';

export const FETCH_ROLES_URL = '/i/organizations/roles';
export const CREATE_ROLE_URL = '/i/organizations/projectTeamRoles';
export const UPDATE_ROLE_URL = '/i/organizations/projectTeamRoles';

export const useRolesQuery = () => useRestQuery(FETCH_ROLES_URL);

export const useCreateRoleMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_ROLE_URL, ApiMethod.post, options);

export const useUpdateRoleMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_ROLE_URL, ApiMethod.put, options);

export type Role = {
  createdAt: number;
  createdBy: string;
  id: number;
  name: string;
  permissions: number[];
  scope: string;
  updatedAt: number;
  updatedBy: string;
};
